// Module
var code = "<div class=loading-spinner><div class=\"spinner loading-spinner-image\"></div><div class=loading-spinner-container style=display:none><div ng-transclude></div></div></div>";
// Exports
module.exports = code;